
/* INKHUB — Mobile-only product Quick View */

document.addEventListener("click", function (event) {
  // Only on mobile screens
  if (!window.matchMedia("(max-width: 767px)").matches) return;

  // Don't interfere with modified clicks
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

  const link = event.target.closest("a");
  if (!link) return;

  const card = link.closest(".product-card");
  if (!card) return;

  // Intercept only product image and title links
  const isImage = link.parentElement?.classList.contains(
    "product-card__image-wrapper"
  );
  const isTitle = link.closest(".product-card__title");

  if (!isImage && !isTitle) return;

  // Use the theme's existing Quick View button
  const quickView = card.querySelector(
    ".product-card__quickview[aria-controls]"
  );

  // If unavailable, keep normal product navigation
  if (!quickView) return;

  event.preventDefault();
  event.stopPropagation();

  quickView.click();
}, true);
